export enum PaymentMode {
  Daily = '001',
  Weekly = '002',
  Monthly = '003',
  Quarterly = '004',
  Annually = '005',
  Others = '006',
  HalfYearly = '007',
  Single = '008',
  Fortnightly = '009',
}
